export default "__VITE_ASSET__DryNGYWl__"